import { Box, Button, Skeleton, Stack, Typography } from '@mui/material'
import { Icons, SkeletonText } from 'utoniq-ui'

import { useTranslation } from '@/core'
import { Cell, CellFrame, Organism, OrganismFrame } from '@/core/architecture'
import { filterHiddenItem } from '@/lib/array'

type ItemDetailBoxSkeletonProps = {
  hiddenSupplementLink?: boolean
  hidden?: {
    trade?: boolean
    serial?: boolean
    expansion?: boolean
  }
}

type SupplementLinkSetCellProps = Pick<ItemDetailBoxSkeletonProps, 'hidden'>

export const ItemDetailBoxSkeleton: Organism<ItemDetailBoxSkeletonProps> = ({
  hiddenSupplementLink,
  hidden,
}) => (
  <OrganismFrame sx={{ py: 2 }}>
    <Stack spacing={5} alignItems="center">
      <Skeleton variant="rectangular" width={280} height={280} />
      <SkeletonText variant="large" width="25%" />
      <Box sx={{ width: '100%' }}>
        <SkeletonText variant="medium" numberOfLine={3} lastWidth="75%" />
      </Box>
    </Stack>
    <Stack sx={{ pt: 1 }}>
      <SkeletonText variant="small" width="50%" />
      <SkeletonText variant="small" width="50%" />
    </Stack>
    {!hiddenSupplementLink && <SupplementLinkSetCell hidden={hidden} />}
  </OrganismFrame>
)

const SupplementLinkSetCell: Cell<SupplementLinkSetCellProps> = ({
  hidden,
}) => {
  const { t } = useTranslation('userItemDetail')
  const supplements = [
    {
      title: 'expansion',
      hidden: hidden?.expansion,
      icon: <Icons.Expansion sx={{ mx: 'auto', color: 'inherit' }} />,
      disabled: false,
    },
    {
      title: 'serial',
      hidden: hidden?.serial,
      icon: <Icons.Serial sx={{ mx: 'auto', color: 'inherit' }} />,
      disabled: false,
    },
    {
      title: 'trade',
      hidden: hidden?.trade,
      icon: <Icons.TradeRequest sx={{ mx: 'auto', color: 'inherit' }} />,
      disabled: false,
    },
  ]
  return (
    <CellFrame sx={{ py: 3 }}>
      <Stack direction="row" sx={{ justifyContent: 'flex-end', py: 2 }}>
        {filterHiddenItem(supplements).map(
          ({ title, icon, disabled }, index) => (
            <Button
              key={index}
              sx={{
                display: 'grid',
                gridTemplateColumns: '1fr',
                p: 1,
                color: 'text.primary',
                borderRadius: 0,
                textAlign: 'center',
                '&.Mui-disabled': {
                  backgroundColor: 'transparent',
                },
              }}
              disabled={disabled}
              variant="text"
            >
              {icon}
              <Typography
                variant="overline"
                color={disabled ? 'text.disabled' : 'text.hint'}
                sx={{ pt: 1 }}
              >
                {t(title)}
              </Typography>
            </Button>
          )
        )}
      </Stack>
    </CellFrame>
  )
}
